import { Expose, Type } from 'class-transformer';

export class RegulatoryDetailsResponseDto {
    @Expose()
    id!: string;

    @Expose()
    clientInformationRecordId!: string;

    @Expose()
    qcManagesProductLifeCycle!: boolean;

    @Expose()
    qcReviewsMasterDocuments!: boolean;

    @Expose()
    qcManagesDel!: boolean;

    @Expose()
    comments?: string;

    @Expose()
    notes?: string;

    @Expose()
    @Type(() => Date)
    createdAt!: Date;

    @Expose()
    @Type(() => Date)
    updatedAt!: Date;
}
